import { Dropdown } from "prism-react";

import { WorkspaceIndication } from "../WorkspaceIndication";

type BaseProps = {
  workspace: { id: string; name: string; avatarUrl: string | null };
  currentUser: { username: string; name: string; avatarUrl: string } | null;
};

const ContextItem: React.FC<
  {
    onSelect?: (e: Event) => void;
  } & BaseProps
> = ({ workspace, currentUser, onSelect }) => {
  return (
    <Dropdown.Item onSelect={onSelect}>
      <WorkspaceIndication currentUser={currentUser} workspace={workspace} />
    </Dropdown.Item>
  );
};

export const ImportOption: React.FC<
  {
    onImportClick: (workspaceId: string, name: string) => void;
  } & BaseProps
> = ({ onImportClick, workspace, currentUser }) => {
  return (
    <ContextItem
      currentUser={currentUser}
      onSelect={() => onImportClick(workspace.id, workspace.name)}
      workspace={workspace}
    />
  );
};
